import ChartBox from "components/ChartBox"
import CounterCard from "components/Charts/CounterCard"
import HalfDonut from "components/Charts/Nivo/HalfDonut"
import HalfPie from "components/Charts/Nivo/HalfPie"
import PieTooltip from "components/Charts/Nivo/tooltips/PieTooltip"
import { PieData } from "interfaces/charts/pie"
import { FormComparasion } from "interfaces/dashboards/formComparasion"

interface Props {
    data: FormComparasion
}

const ThirdQuarterFormsComparasion = ({ data }: Props) => {
    
    const buildChartData = (values: FormComparasion): PieData[] => {
        return [
            {
                id: "preenchidos",
                label: "Preenchidos",
                value: values.finished,
            },
            {
                id: "pendentes",
                label: "Pendentes",
                value: values.awaiting,
            },
        ]
    }

    return (
        <ChartBox title="Formulários de 3º Trimestre">
            <HalfDonut 
                data={buildChartData(data)}
                tooltip={PieTooltip}
            />
        </ChartBox>
    )
}

export default ThirdQuarterFormsComparasion